import { createAction } from "redux-actions";
import {
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
  apiGetFile,
} from "../../api/index";
import {
  urlSessionSecured,
  urlSessionAllSecured,
  urlSessionCompleteSecured,
  urlSessionDocumentSecured,
  urlExportSessionSecured,
} from "../../api/urls";
import { PAGE_SIZE_9 } from "../../constants/index";

const generateFilterQuery = (filterObj) => {
  // Soporta ambas estructuras:
  // 1. { filters: {...}, sort: "...", page: N }
  // 2. { completed: X, initDate: X, sort: "...", ... } (estructura plana)

  const { filters, page, pageSize, sort } = filterObj;

  // Si filters existe, usar eso. Si no, usar el objeto completo como filtros
  const filterData = filters || filterObj;

  let filter = "?";
  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_9);

  if (filterData) {
    if (filterData.uuid !== undefined) filter += "&uuid=" + filterData.uuid;
    if (filterData.date !== undefined) filter += "&date=" + filterData.date;
    if (filterData.initDate !== undefined) {
      filter += "&initDate=" + new Date(filterData.initDate).getTime();
    }
    if (filterData.endDate !== undefined)
      filter += "&endDate=" + new Date(filterData.endDate).getTime();
    if (filterData.completed !== undefined)
      filter += "&completed=" + filterData.completed;
    if (filterData.meetingUuid !== undefined)
      filter += "&meetingUuid=" + filterData.meetingUuid;
    if (filterData.centerUuid !== undefined)
      filter += "&centerUuid=" + filterData.centerUuid;
    if (filterData.farm !== undefined) filter += "&farm=" + filterData.farm;
    if (filterData.employee !== undefined)
      filter += "&employee=" + filterData.employee;
    if (filterData.courseUuid !== undefined)
      filter += "&courseUuid=" + filterData.courseUuid;
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

/**
 * Filter list sessions.
 */
export const filterSession = createAction("FILTER_ITEMS", (filter, param) =>
  apiGet(urlSessionAllSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Get a session.
 */
export const get = createAction("GET_SESSION", (param) =>
  apiGet(urlSessionSecured, param, true)()
);

/**
 * Create session.
 */
export const createSession = createAction("REGISTER_SESSION", (obj) =>
  apiPost(urlSessionSecured, obj, undefined, true)()
);

/**
 * Update session.
 */
export const update = createAction("UPDATE_SESSION", (obj, param) =>
  apiPut(urlSessionSecured, param, obj, true)()
);

/**
 * Complete session.
 */
export const complete = createAction("COMPLETE_SESSION", (obj, param) =>
  apiPut(urlSessionCompleteSecured, obj, param, true)()
);

/**
 * Delete session.
 */
export const removeSession = createAction("DELETE_SESSION", (param) =>
  apiDelete(urlSessionSecured, param, true)()
);

/**
 * Generate a document with signatures
 */
export const generateAttendanceDocument = createAction(
  "GENERATE_DOCUMENT",
  (param) => apiGetFile(urlSessionDocumentSecured, param, true)()
);


export const listSessionToExport = createAction(
  "EXPORT_FILTER_SESSION",
  (filter, param) =>
    apiGet(urlExportSessionSecured + generateFilterQuery(filter), param, true)()
);
